const messages = {
  none: 'bank.offerDetails.none.field',
  bankOfferDetailsSummary: 'bank.offerDetails.summary',
  bankOfferDetailsAccountName: 'bank.offerDetails.accountName',
  bankOfferDetailsInterestRateTitle: 'bank.offerDetails.interestRateTitle',
  bankOfferDetailsInterestRate: 'bank.offerDetails.interestRate',
  bankOfferDetailsChangeRateTitle: 'bank.offerDetails.changeRateTitle',
  bankOfferDetailsEstimatedBalanceTitle: 'bank.offerDetails.estimatedBalanceTitle',
  bankOfferDetailsHowToTitle: 'bank.offerDetails.howToTitle',
  bankOfferDetailsWithdrawalTitle: 'bank.offerDetails.withdrawalTitle',
  bankOfferDetailsAdditionalInfoTitle: 'bank.offerDetails.additionalInfoTitle',
  bankOfferDetailsInterestTabTitle: 'bank.offerDetails.tabTitle.interest',
  bankOfferDetailsInvestTabTitle: 'bank.offerDetails.tabTitle.invest',
  bankOfferDetailsInterestRateEffective: 'bank.offerDetails.interestRateEffective',
  bankOfferDetailsInterestRateNominal: 'bank.offerDetails.interestRateNominal',
  bankOfferDetailsEarlyTerminationInterestRate: 'bank.offerDetails.earlyTerminationInterestRate',
  bankOfferDetailsCompoundInterest: 'bank.offerDetails.compoundInterest',
  bankOfferDetailsTerm: 'bank.offerDetails.term',
  bankOfferDetailsAvailability: 'bank.offerDetails.availability',
  bankOfferDetailsInterestCredit: 'bank.offerDetails.interestCredit',
  bankOfferDetailsInterestPayment: 'bank.offerDetails.interestPayment',
  bankOfferDetailsRepresentativeLabel: 'bank.offerDetails.representativeLabel',
  bankOfferDetailsMonthlyValue: 'bank.offerDetails.monthlyLabel',
  bankOfferDetailsQuarterlyValue: 'bank.offerDetails.quarterly',
  bankOfferDetailsClosureMaturityValue: 'bank.offerDetails.maturity.closure',
  bankOfferDetailsInterestRateChanges: 'bank.offerDetails.interestRateChanges',
  bankOfferDetailsRenewal: 'bank.offerDetails.renewal',
  bankOfferDetailsTermValueIn_days: 'bank.offerDetails.term.value.days',
  bankOfferDetailsTermValueIn_weeks: 'bank.offerDetails.term.value.weeks',
  bankOfferDetailsTermValueIn_months: 'bank.offerDetails.term.value.months',
  bankOfferDetailsTermValueIn_years: 'bank.offerDetails.term.value.years',
  bankOfferDetailsYes: 'bank.offerDetails.yes',
  bankOfferDetailsNo: 'bank.offerDetails.no',
  bankOfferDetailsRate: 'bank.offerDetails.rate',
  settlementDayUnitMONDAY: 'utils.settlementDay.unit.monday',
  settlementDayUnitTUESDAY: 'utils.settlementDay.unit.tuesday',
  settlementDayUnitWEDNESDAY: 'utils.settlementDay.unit.wednesday',
  settlementDayUnitTHURSDAY: 'utils.settlementDay.unit.thursday',
  settlementDayUnitFRIDAY: 'utils.settlementDay.unit.friday',
  settlementDayUnitSATURDAY: 'utils.settlementDay.unit.saturday',
  settlementDayUnitSUNDAY: 'utils.settlementDay.unit.sunday',
  availabilityTerm: 'bank.offerDetails.availability.field.term',
  availabilityOvernight: 'bank.offerDetails.availability.field.overnight',
  availabilityNotice_days: 'bank.offerDetails.availability.field.noticeUnitDays',
  availabilityNotice_months: 'bank.offerDetails.availability.field.noticeUnitMonths',
  availabilityEarlyTermination: 'bank.offerDetails.availability.field.earlyTermination',
  availabilityCallalike: 'bank.offerDetails.availability.field.callalike',
  interestCreditTermWithoutAnnuity: 'bank.offerDetails.field.interestCreditTermWithoutAnnuity',
  interestCreditValue1months: 'bank.offerDetails.field.interestCreditValue1months',
  interestCreditValue3months: 'bank.offerDetails.field.interestCreditValue3months',
  interestCreditValue12months: 'bank.offerDetails.field.interestCreditValue12months',
  interestCreditValue52weeks: 'bank.offerDetails.field.interestCreditValue52weeks',
  overnightOrNoticeRepresentativeValue: 'bank.offerDetails.field.representative.overnightOrNotice',
  overnightRepresentativeValue: 'bank.offerDetails.field.representative.overnight',
  fixedTermRepresentativeValue: 'bank.offerDetails.field.representative.fixedTerm',
  interestPayout: 'bank.offerDetails.field.interestPayout',
  interestPayoutOnInterestCredit: 'bank.offerDetails.field.interestPayoutOnInterestCredit',
  interestPayoutAtMaturity: 'bank.offerDetails.field.interestPayoutAtMaturity',
  interestRateChangesFixedTerm: 'bank.offerDetails.field.interestRateChangesFixedTerm',
  interestRateChangesOthers: 'bank.offerDetails.field.interestRateChangesOthers',
  automaticRenewal: 'bank.offerDetails.renewals.field.automatic',
  manualRenewal: 'bank.offerDetails.renewals.field.manual',
  disabledRenewal: 'bank.offerDetails.renewals.field.disabled',
  currency: 'bank.offerDetails.field.currency',
  possibleInvestmentAmount: 'bank.offerDetails.field.possibleInvestmentAmount',
  costs: 'bank.offerDetails.field.costs',
  noCost: 'bank.offerDetails.field.costs.no',
  withholdingTax: 'bank.offerDetails.field.withholdingTax',
  documentsToBeSubmitted: 'bank.offerDetails.field.documentsToBeSubmitted',
  noAdditionalDocument: 'bank.offerDetails.documentType.noAdditionalDocument',
  digitalDocument: 'bank.offerDetails.documentType.digitalDocument',
  physicalDocument: 'bank.offerDetails.documentType.physicalDocument',
  riskBannerMainHeading: 'risk.banner.heading',
  riskBannerStatutoryGuaranteeText: 'risk.banner.statutory.guarantee.text',
  riskBannerEarlyTerminationAvailableText: 'risk.banner.early.termination.available.text',
  riskBannerEarlyTerminationNotAvailableText: 'risk.banner.early.termination.not.available.text',
};

export default messages;
